export default __webpack_public_path__ + "static/media/8CA1C009-8437-4F0B-B133-0BAAC0EBA66E_1_105_c.69183c3e.jpeg";